import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { useNavigate, useSearch } from '@tanstack/react-router'

import { AppView } from '@/components/templates/AppView/AppView.tsx'
import { useTransportRequests } from '@/model/contexts/useTransportRequests.ts'

import { AppPageDataProvider } from './AppPageDataProvider.tsx'
import { AppPageMapProvider } from './AppPageMapProvider.tsx'
import { AppMapTeamPositionProvider } from './AppPageMapTeamPositionProvider.tsx'
import { AppPageStateProvider } from './AppPageStateProvider.tsx'
import { AppPageTeamsMobileStatusProvider } from './AppPageTeamsMobileStatusProvider.tsx'
import { useDashboardPage } from './useDashboardPage.ts'

const DashboardPageWithProviders: React.FC = () => {
  const appProps = useDashboardPage()
  const { transportRequests } = useTransportRequests()
  const { transportRequestId } = useSearch({ from: '/' })
  const navigate = useNavigate()

  const [highlightedTransportRequestId, setHighlightedTransportRequestId] = useState(transportRequestId)

  useEffect(() => {
    if (highlightedTransportRequestId && transportRequests.some(({ _id }) => _id === highlightedTransportRequestId)) {
      appProps.onHighlight?.(highlightedTransportRequestId)
      setHighlightedTransportRequestId(undefined)
      const url = new URL(globalThis.location.href)
      const params = url.searchParams
      params.delete('transportRequestId')
      globalThis.history.replaceState(null, '', url.href)
    }
  }, [highlightedTransportRequestId, appProps, transportRequests, navigate])

  return <AppView {...appProps} />
}

export const DashboardPage: React.FC = () => {
  const intl = useIntl()

  React.useEffect(() => {
    document.title = intl.formatMessage({ id: 'title' })
  }, [intl])

  return (
    <AppPageMapProvider>
      <AppPageStateProvider>
        <AppPageDataProvider>
          <AppMapTeamPositionProvider>
            <AppPageTeamsMobileStatusProvider>
              <DashboardPageWithProviders />
            </AppPageTeamsMobileStatusProvider>
          </AppMapTeamPositionProvider>
        </AppPageDataProvider>
      </AppPageStateProvider>
    </AppPageMapProvider>
  )
}
